// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"97abd435","336":"317a5054","701":"97abd435","757":"6c5e9792","767":"97abd435","797":"97abd435","903":"5f571501"}[chunkId] + ".chunk.css";
};